import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-scoring-entries', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (student_id, Options = {}) => {
  return httpClient
    .get(`/api/student-scoring-entries/${student_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const findScoring = (student_id, Options = {}) => {
  return httpClient
    .get(
      `/api/student-scoring-entries/find-score-specifict-student/${student_id}`,
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/student-scoring-entries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProgramStructure = (student_id, class_id) => {
  return httpClient
    .get(
      `/api/student-scoring-entries/get-program-structures/${student_id}/${class_id}`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saveComment = data => {
  return httpClient
    .post('/api/student-scoring-entry-comments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateComment = data => {
  return httpClient
    .put(`/api/student-scoring-entry-comments/${data.sc_stu_com_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const findComment = Options => {
  return httpClient
    .get(`/api/student-scoring-entry-comments`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getGradingComponent = (grade_id, sc_bas_id, acps_id) => {
  return httpClient
    .get(
      `/api/student-scoring-entries/grading-components/${grade_id}/${sc_bas_id}/${acps_id}`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoringCycle = Options => {
  return httpClient
    .get('/api/student-scoring-entry/scoring/cycle', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getScoringCycleValue = Options => {
  return httpClient
    .get('/api/student-scoring-entry/scoring/cycle-values', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getAvgScore = (student_id, Options = {}) => {
  return httpClient
    .get(
      `/api/student-scoring-entries/find-avg-score-specifict-student/${student_id}`,
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getAvgScoreBySubject = (student_id, Options = {}) => {
  return httpClient
    .get(
      `/api/student-scoring-entries/find-avg-score-by-subject-specifict-student/${student_id}`,
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const saveDayAbsent = data => {
  return httpClient
    .post('/api/student-scoring-entry-day-absent', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoring = data => {
  return httpClient
    .post('/api/student-scoring-entries/get-scoring', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getComment = data => {
  return httpClient
    .get('/api/student-scoring-entries/get-comments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoreFromAttendance = (student_id, Options = {}) => {
  return httpClient
    .get(
      `/api/student-scoring-entries/find-score-from-att-specifict-student/${student_id}`,
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const storeRatingScale = data => {
  return httpClient
    .post('/api/student-scoring-entries/store-rating-scale', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const findRatingScal = Options => {
  return httpClient
    .get(`/api/student-scoring-entry-rating-scales`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const updateRatingScale = data => {
  return httpClient
    .put(`/api/student-scoring-entry-rating-scales/${data.id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  store,
  find,
  findScoring,
  getProgramStructure,
  saveComment,
  updateComment,
  findComment,
  getGradingComponent,
  getScoringCycle,
  getScoringCycleValue,
  getAvgScore,
  getAvgScoreBySubject,
  saveDayAbsent,
  getScoring,
  getComment,
  getScoreFromAttendance,
  storeRatingScale,
  findRatingScal,
  updateRatingScale
}
